import React, { useRef, useState } from "react";
import { AppointmentDashboardDTO, DocumentDashboardDTO } from "../../../../../api/DashboardWidgetDTO";
import { useMediaQuery, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Avatar, IconButton, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button, useTheme } from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { REACT_APP_PUBLIC_API_URL } from "../../../../../KeyVariables";
import { handleDownload } from "./AnalyzisArchive";

export interface AppointmentsArchiveProps {
  items: AppointmentDashboardDTO[];
}

export const AppointmentsArchive = ({ items }: AppointmentsArchiveProps) => {
  const { t }: { t: any } = useTranslation('Portal');
  const iframeRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
             <TableCell>{t('Portal_CommonDate')}</TableCell>
            <TableCell>{t('Portal_CommonDoctorOffice')}</TableCell>
            <TableCell>{t('Portal_CommonName')}</TableCell>
            <TableCell>{t('Portal_CommonClinic')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.length > 0 ? (
            items.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{item.date ? format(item.date, "dd.MM.yyyy HH:mm") : "-"}</TableCell>
                <TableCell>
                  {item.doctor?.name || "-"}
                </TableCell>
                <TableCell>{item.service?.name || "-"}</TableCell>
                <TableCell>
                  {item.clinic?.name || "-"}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={5} align="center">
                <Typography>{t('Portal_NoAppointments')}</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
